module.exports = __webpack_public_path__ + "img/title.c4f8f6bf.png";